module.exports = __webpack_public_path__ + "static/national-president-logo-f9f9ead04d208e3fe8b1ae12bf60f169.png";